import { createFileRoute } from '@tanstack/react-router';
import { LedgerPage } from '../../features/settlement';

export const Route = createFileRoute('/portal/settlement/ledger')({ component: LedgerPage });
